<template>
  <div class="spl-linehaul-road-list-header">
    <form-button @onClick="handleCreateLinehaulRoad">
      Create Linehaul Drive
    </form-button>
    <form-button
      style="grid-column: 3"
      data-cy="linehaul-road-detail-header-excel"
      @onClick="handleDownload">
      Excel
    </form-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { round } from 'lodash'
import Helpers from '@/helpers.vue'

export default {
  mixins: [Helpers],
  computed: {
    ...mapGetters('linehaulRoad', ['linehaulRoadList'])
  },
  methods: {
    ...mapActions('linehaulRoad', ['updateLinehaulRoad']),
    handleCreateLinehaulRoad () {
      this.$router.push('/linehaul-road-create')
    },
    handleDownload () {
      var excelList = {
        Columns: [],
        Rows: [],
        Filter: {
        }
      }
      var selectedFields = [
        { name: 'Linehaul_Drive_Name', label: 'Drive Name', type: 'String' },
        { name: 'Linehaul_Drive_Detail_Customers', label: 'No. of Customers', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Parcels', label: 'No. of Parcels', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Weight', label: 'Weight', type: 'Number.2' },
        { name: 'Linehaul_Drive_Detail_Load_Meters', label: 'No. of Parcels', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_T1', label: 'No. of Parcels', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Stops', label: 'No. of Parcels', type: 'Number' },
        { name: 'Linehaul_Drive_Detail_Date', label: 'Date', type: 'Date' }
      ]
      // Loop through the columns and add them to excel object
      for (let i = 0; i < selectedFields.length; i++) {
        const field = selectedFields[i]
        excelList.Columns.push({ ID: field.name, Header: field.label, Type: this.getColumnType(field.type) })
      }

      const results = this.linehaulRoadList
      // add the values
      for (let i = 0; i < results.length; i++) {
        var rowValues = { Value: [] }
        const result = results[i]
        for (let j = 0; j < selectedFields.length; j++) {
          const field = selectedFields[j]
          rowValues.Value.push(this.formatField(result[field.name], field.type, field.name))
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      this.getexcelDownload(excelList, 'LinehaulRoads.xlsx')
    },
    getColumnType (fieldType) {
      // Converts the formats into excel compatible ones
      // "Number", "DateTime", "Text", "Boolean"
      if (fieldType) {
        switch (fieldType) {
          case 'Number':
          case 'Number.3':
            return 'Number'
          case 'Number.2':
            return 'Number.2'

          case 'Boolean' :
            return 'Boolean'

          case 'Date':
          case 'Timestamp':
            return 'DateTime'

          case 'String':
          default:
            return 'Text'
        }
      }
      return ''
    },
    // Special formatting for fields
    formatField (field, type, name) {
      // empty fields will be removed
      if (field === null) {
        return ''
      }
      switch (type) {
        case 'Number.2':
          return round(field, 2).toFixed(2)
        case 'Number.3' :
          return round(field, 3).toFixed(3)
        case 'Date':
          return this.formatDate(field, false, 'YYYY-MM-DD')
        case 'Timestamp':
          return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      }
      return field
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .spl-linehaul-road-list-header {
    position: relative;
    padding: 0 $mainPadding;
    margin: 15px 0;
  }

</style>
